import OkC from "shared/util/OkcApi";

import {
	PROFILE_ALBUM_ID,
	INSTAGRAM_ALBUM_ID,
} from "apps/profile_instagram/util/constants";

const loadAlbumImages = ({ userid, albumId }) => {
	const path = albumId
		? `/profile/${userid}/albums/${albumId}`
		: `/profile/${userid}/photos`;

	return OkC.get(path);
};

const loadInstagramImages = ({ userid }) => {
	return OkC.get(`/profile/${userid}/photos/instagram`);
};

export const loadImages = ({ userid, albumId }) => {
	if (albumId === PROFILE_ALBUM_ID) {
		return loadAlbumImages({ userid, albumId });
	} else if (albumId === INSTAGRAM_ALBUM_ID) {
		return loadInstagramImages({ userid });
	} else {
		return Promise.reject(`loadImages was called with an invalid album id: ${albumId}`);
	}
};



// WEBPACK FOOTER //
// ./src/apps/photo_overlay/util/web.js